// Delivering the reset link always answers 204: this action carries no business payload,
// only the notification signal (`eventName` matches this `type` exactly).
export type PasswordResetRequestedAction = {
	type: 'PASSWORD_RESET_LINK_REQUESTED';
};

export default (): PasswordResetRequestedAction => ({
	type: 'PASSWORD_RESET_LINK_REQUESTED',
});
